<script lang="ts" setup>
import AppHeader from "~/widgets/layout/AppHeader.vue";
import StickyMenu from "~/widgets/layout/StickyMenu.vue";
import AppFooter from "~/widgets/layout/AppFooter.vue";
import Preloader from "~/components/ui/preloader/Preloader.vue";
import Breadcrumbs from "~/components/ui/breadcrumbs/Breadcrumbs.vue";
import RandomBanner from "~/features/banners/RandomBanner.vue";
import useCatalogStore from "~/shared/store/modules/catalog";
import getNumberWithSpaces from "~~/composables/number-formatter";
import SmallBanners from "~/components/ui/banners/SmallBanners.vue";
import BackLink from "~/components/ui/links/BackLink.vue";
import MainTitle from "~/components/ui/title/MainTitle.vue";
import type { IBreadcrumbs } from "~/shared/interfaces/ui/breadcrumbs";
import type { ICatalogCategory } from "~/shared/interfaces/catalog";

// TODO: временно
import PresentationHBFastenersPDF from "assets/docs/hb/hb-presentation-fasteners.pdf";
import PresentationHBShockAbsorbersPDF from "assets/docs/hb/presentation-shock-absorbers.pdf";
import PresentationHBDiscBrakePadsPDF from "assets/docs/hb/presentation-disc-brake-pads.pdf";
import PresentationHBDiscBrakePDF from "assets/docs/hb/presentation-brake-discs.pdf";
import PresentationHBEnergyAccAndBraceChambersPDF from "assets/docs/hb/presentation-energy-accumulators-brake-chambers.pdf";
import PresentationHBSixPDF from "assets/docs/hb/six.pdf";
import PresentationHBSevenPDF from "assets/docs/hb/seven.pdf";
import PresentationHBEightPDF from "assets/docs/hb/eight.pdf";
import PresentationHBNinePDF from "assets/docs/hb/nine.pdf";
import DownloadIcon from "assets/icons/download-icon-white.svg";


const route = useRoute();

let routeUrl = ref<string[]>(getRouteUrl());

const catalogStore = useCatalogStore();
const productsDeclension = computed(() => {
  const num = catalogStore.catalog?.total ? catalogStore.catalog.total % 10 : 0;
  return num === 1 ? "товар" : num > 1 && num < 5 ? "товара" : "товаров";
});

const getTitle = computed(() => {
  if (
    routeUrl.value &&
    catalogStore.openedCategory?.name &&
    route.name !== "catalog"
  ) {
    return catalogStore.openedCategory.name;
  }
  return "Каталог";
});

// TODO: временно
const getIsPresentation = computed(() => {
  const presentationsOne = ['shpilki', 'bolty-kolesnye-harbinger', 'gayki-harbinger', 'gayki-kolesnye-harbinger', 'gayki-kolesnye']
  const presentationsTwo = ['valy-tormoznye', 'valy-tormoznye-harbinger']
  const presentationsThree = ['kolodki-tormoznye', 'kolodki-diskovye-harbinger']
  const presentationsFour = ['diski-tormoznye', 'diski-tormoznye-harbinger']
  const presentationsFive = ['kamery-tormoznye', 'energoakkumulyatory-harbinger']
  const presentationsSix = ['nakladki-tormoznye-harbinger']
  const presentationsSeven = ['harbinger']
  const presentationsEight = ['filtry-vozdushnye-harbinger', 'filtry-kabiny-harbinger']
  const presentationsNine= ['filtry-maslyanye-harbinger', 'filtry-okhlazhdayushchey-zhidkosti-harbinger', 'filtry-toplivnye-harbinger']

  if(route.name == "catalog") return false

  if (
    routeUrl.value &&
    catalogStore.openedCategory?.slug &&
    catalogStore.openedCategory.slug
  ) {
    if(presentationsOne.includes(catalogStore.openedCategory.slug)) {
      return PresentationHBFastenersPDF
    }
    if(presentationsTwo.includes(catalogStore.openedCategory.slug)) {
      return PresentationHBShockAbsorbersPDF
    }
    if(presentationsThree.includes(catalogStore.openedCategory.slug)) {
      return PresentationHBDiscBrakePadsPDF
    }
    if(presentationsFour.includes(catalogStore.openedCategory.slug)) {
      return PresentationHBDiscBrakePDF
    }
    if(presentationsFive.includes(catalogStore.openedCategory.slug)) {
      return PresentationHBEnergyAccAndBraceChambersPDF
    }
    if(presentationsSix.includes(catalogStore.openedCategory.slug)) {
      return PresentationHBSixPDF
    }
    if(presentationsSeven.includes(catalogStore.openedCategory.slug)) {
      return PresentationHBSevenPDF
    }
    if(presentationsEight.includes(catalogStore.openedCategory.slug)) {
      return PresentationHBEightPDF
    }
    if(presentationsNine.includes(catalogStore.openedCategory.slug)) {
      return PresentationHBNinePDF
    }
    return false
  }
  return false;
});

const breadcrumbsList = computed(() => {
  const slugsList = routeUrl.value as string[];
  const breadcrumbs: IBreadcrumbs[] = [
    {
      uuid: "catalog",
      name: "Каталог",
      slug: "catalog",
    },
  ];

  let categoriesList: ICatalogCategory[] = catalogStore.catalogCategories;

  if (slugsList?.length && categoriesList.length) {
    slugsList.forEach((slugListItem) => {
      let currentCategory =
        categoriesList.find((category) => category.slug === slugListItem) ||
        null;

      if (currentCategory) {
        const { uuid, name, slug, parentId, photoUrl } = currentCategory;
        breadcrumbs.push({
          uuid,
          name,
          slug,
          parentId,
          photoUrl,
        });

        categoriesList = currentCategory.childCategories;
      }
    });
  }

  return breadcrumbs;
});

function getRouteUrl() {
  return useRequestURL()
    .pathname.split("/")
    .filter((el) => el);
}

watch(
  () => route.path,
  () => (routeUrl.value = getRouteUrl())
);
</script>

<template>
  <div class="app-wrap">
    <AppHeader />
    <main class="main">
      <RandomBanner
        v-if="route.fullPath !== '/catalog'"
        api-endpoint="search"
      />
      <ClientOnly>
        <Breadcrumbs
          v-if="breadcrumbsList.length > 1"
          :breadcrumbs="breadcrumbsList"
        />
      </ClientOnly>
      <BackLink v-if="route.fullPath !== '/catalog'" class="catalog__back-link"/>
      <div class="container">
        <div
          class="catalog-header"
          :class="route.fullPath === '/catalog' && 'catalog-header_main'"
        >
          <MainTitle class="catalog-header__title" :text="getTitle" size="s">
            <ClientOnly>
              <span
                class="catalog-header__title-total"
                v-if="
                  !catalogStore.currentCategories &&
                  catalogStore.catalog &&
                  route.fullPath !== '/catalog'
                "
              >
                {{ getNumberWithSpaces(catalogStore.catalog?.total || 0) }}
                {{ productsDeclension }}
              </span>
            </ClientOnly>
          </MainTitle>

          <!--          TODO: временно-->
          <div
            v-if="getIsPresentation"
            class="catalog-header__presentation"
          >
            <a :href="getIsPresentation" class="catalog-header__presentation-link" download>
              <div class="catalog-header__presentation-text">
                <p>Узнайте о запчастях Harbinger</p>
              </div>
              <div class="catalog-header__presentation-text">
                <DownloadIcon class="catalog-header__presentation-icon" />
                <p>Скачать презентацию</p>
              </div>
            </a>
          </div>

        </div>
        <SmallBanners v-if="route.fullPath === '/catalog'" />
        <suspense>
          <slot />
        </suspense>
      </div>
    </main>
    <ClientOnly>
      <StickyMenu />
    </ClientOnly>
    <div id="main-under-content"></div>
    <AppFooter />
    <Preloader />
  </div>
</template>

<style lang="scss" scoped>
.small-banners {
  margin-bottom: 40px;
  @include md-breakpoint {
    margin-bottom: 20px;
  }
}

.breadcrumbs {
  @include md-breakpoint {
    display: none;
  }
}

.back-link {
  display: none;
  @include md-breakpoint {
    display: flex;
    .main:not(:has(.banner)) & {
      padding-top: 20px;
    }
  }
}

.catalog {
  &__back-link {
    @include md-breakpoint {
      padding-top: 0;
    }
  }

  &-header {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    padding: 16px 0 24px 0;
    @include md-breakpoint {
      padding: 16px 0 20px;
    }
    @include sm-breakpoint {
      flex-direction: column;
    }

    &__presentation {
      &-link {
        display: flex;
        flex-direction: column;
        justify-content: center;
        background-color: #299a41;
        color: $control-content_white;
        @include btn-svg-color($control-content_white);
        height: 52px;
        padding: 0 20px;
        min-width: 96px;
        border-radius: 8px;
        @include font(16px, 20px, 500);
        transition: color .3s, background-color .3s, opacity 3s, border-color .3s;
        white-space: nowrap;
        flex-shrink: 0;
        width: fit-content;
        &:hover:not(:active, .active, .disabled) {
          @include mf-breakpoint {
            background-color: $control-bg_primary-hover;
          }
        }
      }
      &-text {
        display: flex;
        gap: 4px;
        align-items: center;
      }
    }

    &_main {
      padding: 40px 0 28px 0;
      @include md-breakpoint {
        padding: 28px 0 20px;
      }

      .catalog-header__title {
        @include font(36px, 44px, 700);
        @include md-breakpoint {
          @include font(28px, 32px, 600);
        }
      }
    }

    &__title {
      color: $content_primary;
      @include md-breakpoint {
        display: flex;
        flex-direction: column;
        gap: 4px;
      }

      &-total {
        color: $content_secondary;
        @include font(16px, 20px);
      }
    }
  }
}
.main {
  background-color: $bg_page;
  padding: 128px 0 60px;
  @include md-breakpoint {
    padding: 132px 0 40px;
  }
}
</style>
